"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamChart = void 0;
const React = __importStar(require("react"));
const stream_1 = require("@nivo/stream");
const constants_1 = require("./utils/constants");
const getOffsetType = (type) => {
    if (type)
        return type;
    return constants_1.OffsetType.NONE;
};
const getCurveStyle = (curveStyle) => {
    if (curveStyle)
        return curveStyle;
    return constants_1.CurveStyle.NATURAL;
};
const getColoScheme = (colorScheme) => {
    if (colorScheme)
        return colorScheme;
    return constants_1.NivoColorScheme.NIVO;
};
const getLegends = (enableLegend) => {
    return enableLegend
        ? [
            {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 100,
                itemWidth: 80,
                itemHeight: 20,
                itemTextColor: '#999999',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000000',
                        },
                    },
                ],
            },
        ]
        : undefined;
};
exports.StreamChart = (props) => {
    const { keys, data, fill, offsetType, curveStyle, colorScheme, enableLegend } = props;
    return (React.createElement(stream_1.ResponsiveStream, { data: data, keys: keys, margin: { top: 50, right: 60, bottom: 50, left: 60 }, offsetType: getOffsetType(offsetType), colors: { scheme: getColoScheme(colorScheme) }, fillOpacity: 0.85, curve: getCurveStyle(curveStyle), fill: fill, legends: getLegends(enableLegend), enableGridX: true, enableGridY: true }));
};
//# sourceMappingURL=data:application/json;base64,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